import { render, staticRenderFns } from "./OrderArchive.vue?vue&type=template&id=10daa802&scoped=true"
import script from "./OrderArchive.vue?vue&type=script&lang=js"
export * from "./OrderArchive.vue?vue&type=script&lang=js"
import style0 from "./OrderArchive.vue?vue&type=style&index=0&id=10daa802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10daa802",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
